import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MenuService } from '../services/menu.service';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';

@Component({
  selector: 'app-sidebar-menu',
  imports: [
    CommonModule,
    MatIcon,
    RouterLink,
    RouterLinkActive
],
  templateUrl: './sidebar-menu.component.html',
  styleUrl: './sidebar-menu.component.css'
})
export class SidebarMenuComponent {

  @Input() expanded!: boolean;

  constructor(
    public menuService: MenuService,
    public router: Router,
  ){}
}
